/* eslint-disable react/no-array-index-key */
import React, { Component } from 'react';
import YouTube from 'react-youtube';
import { FeaturedProEventCard, LoadingCard } from '../../cards';

class FeaturedProEvents extends Component {
    constructor() {
        super();
        this.state = {};
    }

    render() {
        const { featuredProEvents = [] } = this.props;
        const getVideoLink = (videolink) => {
            return videolink.split('v=')[1];
        };

        return (
            <div className="container">
                <div className={`hp-spacing`}>
                    <div className={`hp-title`}>
                        {featuredProEvents.title}
                    </div>
                    {featuredProEvents && featuredProEvents.data && featuredProEvents.data.length ? (
                        <div className="row">
                            {featuredProEvents.data.map((featuredItem, i) => {
                                return (
                                    <div className={`col-12 col-md-6 mb10`} key={`featuredEvent-${i}`}>
                                        {(featuredItem.videolink) ? (
                                            <React.Fragment>
                                                <YouTube
                                                    className="d-none d-sm-block"
                                                    videoId={getVideoLink(featuredItem.videolink)}
                                                    opts={{
                                                        height: '288',
                                                        width: '100%',
                                                        playerVars: {
                                                            autoplay: 0,
                                                            controls: 0,
                                                            mute: 0,
                                                            loop: 1,
                                                            playlist: getVideoLink(featuredItem.videolink),
                                                        },
                                                    }}
                                                />
                                                <YouTube
                                                    className="d-block d-sm-none"
                                                    videoId={getVideoLink(featuredItem.videolink)}
                                                    opts={{
                                                        height: '168',
                                                        width: '100%',
                                                        playerVars: {
                                                            autoplay: 0,
                                                            controls: 0,
                                                            mute: 0,
                                                            loop: 1,
                                                            playlist: getVideoLink(featuredItem.videolink),
                                                        },
                                                    }}
                                                />
                                            </React.Fragment>
                                        ) : (
                                            <FeaturedProEventCard
                                                title={featuredItem.title}
                                                copy={featuredItem.description}
                                                image={featuredItem.image}
                                                overlayPercent={featuredItem.overlay_percent}
                                                link={featuredItem.itemlink}
                                            />

                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    ) : (
                        <div className="row">
                            <div className={`col-12 col-md-6`}>
                                <LoadingCard />
                            </div>
                            <div className={`d-none d-md-block col-md-6`}>
                                <LoadingCard />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default FeaturedProEvents;
